import { render, staticRenderFns } from "./modalAddendums.vue?vue&type=template&id=d7fb5de4&"
import script from "./modalAddendums.vue?vue&type=script&lang=js&"
export * from "./modalAddendums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports